import React, { lazy, Suspense } from "react";
import mainStyle from "./main.module.css";
import Header from "./Components/Header/Header";
const Heros = lazy(() => import("./Components/hero_section"));
const QuickGlance = lazy(() => import("./Components/QuickGlance"));
const Ticker = lazy(() => import("./Components/Ticker"));
const Features = lazy(() => import("./Components/Features"));
const Testimonial = lazy(() => import("./Components/Testimonials"));
const OtherFeature = lazy(() => import("./Components/OtherFeature"));
const Hardware = lazy(() => import("./Components/Hardware"));
const Industries = lazy(() => import("./Components/Industries"));
const OurAwards = lazy(() => import("./Components/OurAwards"));
const Footer = lazy(() => import("./Components/Footer"));
const News = lazy(() => import("./Components/News"));
const IotDevices = lazy(() => import("./Components/IotDevices"));
const UseCases = lazy(() => import("./Components/UseCases"));
const Api = lazy(() => import("./Components/API"));

const WMS = () => {
	const [selectedFeature, setSelectedFeature] = React.useState(0);
	const [selectedIndustry, setSelectedIndustry] = React.useState(0);

	return (
		<div className={mainStyle.landing_page} style={{ overflowX: "hidden" }} >
			<Header  setSelectedFeature={setSelectedFeature} />
			 <Suspense fallback={<div>Loading...</div>}>
			<div className={mainStyle.section_wrapper} style={{ position: "relative" }}>
				<section id="heros" className={mainStyle.section} style={{ position: "relative" }}>
					<Heros />
				</section>

				<section className={mainStyle.section} style={{ background: "#fff", position: "relative" }}>
					<Ticker />
				</section>

				<section className={mainStyle.section} style={{ background: "#fff", position: "relative" }}>
					<QuickGlance />
				</section>

				<section id="features" className={mainStyle.section} style={{ background: "#fff", position: "relative" }}>
					<Features setCurrent={setSelectedFeature} current={selectedFeature} />
				</section>

				<section className={mainStyle.section} style={{ background: "#fff", position: "relative" }}>
					<Testimonial />
				</section>

				<section id='usecases' className={mainStyle.section} style={{ background: "#fff", position: "relative" }}>
					<UseCases />
				</section>

				<section className={mainStyle.section} style={{ position: "relative" }}>
					<OtherFeature setCurrent={setSelectedFeature} current={selectedFeature} />
				</section>

				<section id="hardware-products" className={mainStyle.section} style={{ position: "relative" }}>
					<Hardware />
				</section>

				<section className={mainStyle.section} style={{ position: "relative" }}>
					<IotDevices />
				</section>

				<section id="api" className={mainStyle.section} style={{ position: "relative" }}>
					<Api />
				</section>

				<section className={mainStyle.section} style={{ position: "relative" }}>
					<Industries setCurrent={setSelectedIndustry} current={selectedIndustry} />
				</section>

				<section className={mainStyle.section} style={{ position: "relative" }}>
					<OurAwards />
				</section>

				<section className={mainStyle.section} style={{ position: "relative" }}>
					<News />
				</section>
				{/* <section
          			className={mainStyle.section}
          			style={{ position: "relative" }}
        		>	
          		<Linkedin />
        		</section>  */}
        {/* <section className={mainStyle.section} style={{ position: "relative" }}>
					<News />
				</section> */}
				{/*
        <section
          className={mainStyle.section}
          style={{position:'relative', minHeight: "auto"}}
          id="useCases"
        >
          <SupplyChainNew/>
        </section>

        <section
          className={mainStyle.section}
          style={{ position: "relative" }}
        >
          <Reviews />
        </section>
  
      


        <section
          className={mainStyle.section}
          style={{ position: "relative" }}
          id="api"
        >
          <API />
        </section>
        
      
        <section
          className={mainStyle.section}
          style={{ position: "relative" }}
        >
          <LatestNews />
        </section>*/}

			</div>
			<section className={mainStyle.section} style={{ position: "relative" }}>
				<Footer />
			</section>
			</Suspense>
		</div>
	);
};

export default WMS;
